import React, { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { IntegrationSettingsPropertyDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsPropertyDropdown/IntegrationSettingsPropertyDropdown'
import { IntegrationSettingsPropertyTable } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsPropertyTable/IntegrationSettingsPropertyTable'
import type { IntegrationSalesforceSettingsPropertyStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationSalesforceSettings/store/IntegrationSalesforceSettingsPropertyStore'
import styles from './styles.module.scss'

type IIntegrationSalesforceSettingsPropertyProps = {
  store: IntegrationSalesforceSettingsPropertyStore
}

export const IntegrationSalesforceSettingsProperty: FC<IIntegrationSalesforceSettingsPropertyProps> =
  observer(({ store }) => {
    const {
      rows,
      loading,
      numberEnabled,
      setNumberEnabled,
      integrationName,
      isLimitedIntegration,
      showSaveControl,
      saveNewProperties,
      clearNewProperties,
      customPropertyStore,
    } = store

    return (
      <div className={styles.root}>
        {!isLimitedIntegration && (
          <TitledRow
            title={'Use custom phone number field'}
            label={'Update custom phone number for Lead and Contact'}
            verticalAlign={'start'}
          >
            <Switch size='middle' value={numberEnabled} onChange={setNumberEnabled} />
          </TitledRow>
        )}
        <IntegrationSettingsPropertyTable
          rows={rows}
          loading={loading}
          integrationName={integrationName}
          integrationIcon={'salesforce'}
        />
        {!customPropertyStore.withoutPropertiesMapping && (
          <div className={styles.footer}>
            <IntegrationSettingsPropertyDropdown store={customPropertyStore} rows={rows} />
            {showSaveControl && (
              <div className={styles.control}>
                <Button
                  text='Cancel'
                  typeBtn='contained'
                  contained='secondary'
                  size='medium'
                  onClick={clearNewProperties}
                />
                <Button
                  text='Save'
                  typeBtn='contained'
                  contained='primary'
                  size='medium'
                  onClick={saveNewProperties}
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  })
